import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCouponCode, blockUnblockCouponCode, couponCodeListing, deleteCouponCode, editCouponCode, viewCouponCode } from "../apis/apiHandler";

export const allCouponCodes = createAsyncThunk(
    'coupon/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await couponCodeListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addCouponCodes = createAsyncThunk(
    'coupon/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addCouponCode(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editCouponCodes = createAsyncThunk(
    'coupon/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editCouponCode(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewCouponCodeDetails = createAsyncThunk(
    'coupon/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewCouponCode(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteCouponCodes = createAsyncThunk(
    'coupon/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteCouponCode(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeCouponCodeStatus = createAsyncThunk(
    'coupon/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockCouponCode(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    couponCodeList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    couponCodeDetail: {},
    deleteSuccess: false,
    statusSuccess: false
};

const couponCodeSlice = createSlice({
    name: 'coupon_code',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allCouponCodes.pending, (state) => {
                state.loading = true;
            })
            .addCase(allCouponCodes.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.couponCodeList = payload?.data;
            })
            .addCase(allCouponCodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addCouponCodes.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addCouponCodes.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addCouponCodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editCouponCodes.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editCouponCodes.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editCouponCodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewCouponCodeDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewCouponCodeDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.couponCodeDetail = payload?.data;
            })
            .addCase(viewCouponCodeDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteCouponCodes.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteCouponCodes.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteCouponCodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeCouponCodeStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeCouponCodeStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeCouponCodeStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
    }
})

export default couponCodeSlice.reducer;